import { render, staticRenderFns } from "./list.vue?vue&type=template&id=b6d83814&scoped=true"
import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=b6d83814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d83814",
  null
  
)

export default component.exports